import { X } from 'lucide-react'
import { ReactNode } from 'react'

// Definimos los tipos de las props
interface ModalProps {
  isOpenModal: boolean
  closeModal: () => void
  children: ReactNode
  iconModal?: ReactNode
  titleModal?: string
  subTitleModal?: string
}

export const Modal = ({
  isOpenModal,
  closeModal,
  children,
  iconModal,
  titleModal,
  subTitleModal
}: ModalProps): JSX.Element => {
  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center transition-opacity duration-500 ${isOpenModal ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      onClick={closeModal}
    >
      <div
        className='relative bg-white rounded-lg shadow-lg w-full max-w-md'
        onClick={(e) => e.stopPropagation()} // Prevenir el cierre al hacer clic dentro del modal
      >
        <button
          className='absolute top-8 right-2 p-1 bg-white rounded-full hover:bg-gray-200 transition'
          onClick={closeModal}
          aria-label='Cerrar Modal'
        >
          <X className='text-black' size={24} /> {/* Icono de cierre */}
        </button>

        {/* Título del modal y subtítulo opcionales */}
        {iconModal !== undefined && <div className='flex justify-center mb-4'>{iconModal}</div>}
        {titleModal !== undefined && <h2 className='text-xl font-bold text-center'>{titleModal}</h2>}
        {subTitleModal !== undefined && <p className='text-center text-gray-600 mb-4'>{subTitleModal}</p>}

        {/* Contenido del modal */}
        {children}
      </div>
    </div>
  )
}
